package com.starparty.app.astro0

import com.starparty.app.geometry.SP_Point
import com.starparty.app.vector_maths.Matrix4d
import com.starparty.app.vector_maths.Point2d
import com.starparty.app.vector_maths.Point3d

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
abstract class Projection(var matrix: Matrix4d) {
    val maxZoom = 100000.0
    val minZoom = 500.0

    var zoomFactor: Double = 500.0
        set(value) {
            field = value.coerceIn(minZoom, maxZoom)
            matrix.setScale(zoomFactor)
        }

    protected var translation: Point3d = Point3d()

    abstract fun invertProjection(p: SP_Point?): Point3d

     fun incrementZoom(inc: Double) {
         zoomFactor *= inc
    }

    open fun project(c: Point3d): Point2d {
        return Projection.projectFromMatrix(c, matrix)
    }


    companion object {
        fun projectFromMatrix(c: Point3d, m: Matrix4d): Point2d {
            val p0 = c.x * m.m00 + c.y * m.m10 + c.z * m.m20 + m.m30
            val p1 = c.x * m.m01 + c.y * m.m11 + c.z * m.m21 + m.m31
            val p2 = c.x * m.m02 + c.y * m.m12 + c.z * m.m22 + m.m32
            val p3 = c.x * m.m03 + c.y * m.m13 + c.z * m.m23 + m.m33
            val x = p0 / p3
            val y = p1 / p3
            return Point2d(x, y)
        }
    }

    fun translate(x:Double, y:Double, z:Double){

        translateBackToOrigin()
        translation.set(x, y, z)
        matrix.translate(x, y, z)
    }

    protected fun translateBackToOrigin(){
        matrix.translate(-translation.x, -translation.y, -translation.z)
        translation.set(0.0,0.0,0.0)
    }

    init {
        matrix.setScale(zoomFactor)
    }
}